import React, { Component } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@material-ui/core";
import LockOutlineIcon from "@material-ui/icons/LockOutlined";
//login con telefono para habilitar el captcha - npm install firebase firebaseui --save
import * as firebaseui from "firebaseui";
//objeto firebase
import { consumerFirebase } from "../../server";
//para poder extraer el valor del dispatch necesitamos importar el StateContext del archivo session/store.js
import { StateContext } from "../../session/store";
//para mensajes de error para el metodo verifyNumber y loginWithPhone
import { openMessageError } from "../../session/actions/openMessageAction";

const style = {
  paper: {
    marginTop: 9,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: 5,
    backgroundColor: "#e53935"
  },
  form: {
    width: "100%",
    marginTop: 8
  },
  submit: {
    marginTop: 10,
    marginBottom: 10
  },
  captcha: {
    flexGrow: 1,
    marginBottom: 10
  }
};

class PhoneLogin extends Component {
  //para acceder al context global de   const [{  userCode }, dispatch] = this.context; desde import { StateContext } from "../../session/store";
  static contextType = StateContext;

  state = {
    disable: true,
    dialogOpen: false,
    userCode: {
      phone: "",
      code: ""
    },
    codeFirebase: null
  };
  //habilita la funcionalidad del captcha en firebase
  componentDidMount() {
    //de firebaseConsumer
    const { firebase } = this.props;

    firebase.auth.languageCode = "es";
    window.recaptchaVerifier = new firebase.authorization.RecaptchaVerifier(
      this.recaptcha,
      {
        size: "normal",
        callback: response => {
          this.setState({
            //habilita el boton para enviar el mensaje
            disable: false
          });
        },
        "expired-callback": function() {
          this.setState({
            //anula el boton de enviar mensaje cuando este ha sido enviado
            disable: true
          });
          //para actualizar los datos en el perfil de userCode reiniciando el captcha
          window.location.reload();
        }
      }
    );
    window.recaptchaVerifier.render().then(function(widgetID) {
      window.recaptchaVerifierId = widgetID;
    });
  }

  //almacena valores de cajas de texto como variables de estado del componente
  onChange = e => {
    let userCode = Object.assign({}, this.state.userCode);
    userCode[e.target.name] = e.target.value;
    this.setState({ userCode });
  };

  //metodo del boton enviar codigo al telefono
  verifyNumber = e => {
    e.preventDefault();
    // this.setState({
    //   dialogOpen: true
    // });
    const { firebase } = this.props;
    const appVerification = window.recaptchaVerifier;
    //para openMessageError - mejora
    const [{ sesion }, dispatch] = this.context;
    console.log(sesion);

    firebase.auth
      .signInWithPhoneNumber(this.state.userCode.phone, appVerification)
      //cuando el codigo sea enviado
      .then(sentCode => {
        this.setState({
          dialogOpen: true,
          codeFirebase: sentCode
        });
      })
      // mejora de mensajes de error
      .catch(error => {
        openMessageError(dispatch, {
          open: true,
          message: error.message
        });
      });
  };

  //metodo para validar codigo enviado por sms al telefono
  //realizar autenticacion en firebase
  loginWithPhone = () => {
    //objeto firebase
    const { firebase } = this.props;

    //autorizacion del objeto firebase
    let credentialFirebase = firebase.authorization.PhoneAuthProvider.credential(
      this.state.codeFirebase.verificationId,
      this.state.userCode.code
    );
    //console.log(credentialFirebase);

    //objeto  userCode y dispath del useContext
    //para openMessageError
    const [{ usuario }, dispatch] = this.context;
    console.log(usuario);

    firebase.auth
      //.signInWithCredential(credential)
      .signInAndRetrieveDataWithCredential(credentialFirebase)
      .then(authUser => {
        firebase.db
          .collection("Users")
          .doc(authUser.user.uid)
          .set(
            {
              id: authUser.user.uid,
              phone: authUser.user.phoneNumber
            },
            { merge: true }
          )
          .then(success => {
            //para el reflesh una vez realizado el login - mejora
            firebase.db
              .collection("Users")
              .doc(authUser.user.uid)
              .get()
              .then(doc => {
                //actualizar la variable global de  userCode del context global de la app
                dispatch({
                  type: "START_SESSION",
                  sesion: doc.data(),
                  signin: true
                });
                this.props.history.push("/");
              });
          });
      })
      // mejora de mensajes de error
      .catch(error => {
        openMessageError(dispatch, {
          open: true,
          message: error.message
        });
      });
  };

  render() {
    return (
      <Container maxWidth="xs">
        <Dialog
          open={this.state.dialogOpen}
          onClose={() => {
            this.setState({ dialogOpen: false });
          }}
        >
          <DialogTitle>Ingrese su código</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Ingrese el código recibido por mensaje de texto
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              name="code"
              value={this.state.userCode.code}
              onChange={this.onChange}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                this.setState({ dialogOpen: false });
              }}
            >
              Cancelar
            </Button>
            <Button color="primary" onClick={this.loginWithPhone}>
              Verificar
            </Button>
          </DialogActions>
        </Dialog>

        <div style={style.paper}>
          <Avatar style={style.avatar}>
            <LockOutlineIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Login por teléfono
          </Typography>
          <form style={style.form}>
            <Grid container style={style.captcha} justify="center">
              <div ref={ref => (this.recaptcha = ref)}></div>
            </Grid>
            <TextField
              variant="outlined"
              fullWidth
              name="phone"
              label="enter phone number"
              value={this.state.userCode.phone}
              onChange={this.onChange}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              style={style.submit}
              onClick={this.verifyNumber}
              disabled={this.state.disable}
            >
              Enviar...
            </Button>
          </form>
        </div>
      </Container>
    );
  }
}

export default consumerFirebase(PhoneLogin);
